export const financialStatusEnum = {
  pending: "pending", //待付款
  paid: "paid", //已付款
  canceled: "canceled", // 已取消
  partially_refunded: "partially_refunded", // 部分退款
  refunded: "refunded", // 已退款
  authorized: "authorized", // 已授权， 支付已被授权，但尚未实际扣款。
  refunding: "refunding", // 退款中
};

export const fulfillmentStatusEnum = {
  hold: 'hold', // 待发货
  fulfilled: 'fulfilled', // 已发货
  none: 'none', // 无需发货
  not_requires: 'not_requires', //无需发货
  confirmed: 'confirmed', //已确认
  partial: 'partial', // 部分发货
};

export const statusEnum = {
  unpaid: 0, // 待付款
  preparing: 1, //待发货
  arriving: 2, // 待收货
  completed: 3, // 已完成
  cancelled: 4, // 已取消
  all: -1, // 全部
}

export const payMethodMap = {
  PayPal: 106,
  Stripe: 111,
}